/*
 * @Author: your name
 * @Date: 2021-01-26 13:47:02
 * @LastEditTime: 2021-01-26 14:22:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/utils/uuid.js
 */
import {
  v4 as uuidv4
} from 'uuid'

const _generateUuidOrderId = function () {
  return uuidv4()
}

export {
  _generateUuidOrderId
}